{
  "es": {
    "chart": {
      "type": {
        "bar": "Gráfico de barras",
        "bubble": "Gráfico de burbujas",
        "doughnut": "Gráfico de anillos",
        "horizontalBar": "Gráfico de barras horizontales",
        "line": "Gráfico de líneas",
        "multiAxis": "Gráfico multieje",
        "pie": "Gráfico circular",
        "polarArea": "Gráfico de área polar",
        "radar": "Gráfico de radar",
        "stackedBar": "Gráfico de barras apiladas"
      }
    }
  }
}
